<div class="flex flex-row justify-between items-center gap-3">
  <p i18n class="header-text">Выберите облицовку</p>
  <button i18n-matTooltip matTooltip="Выбрать другую" mat-icon-button (click)="openButtListDialog()">
    <mat-icon>add_circle_outline</mat-icon>
  </button>
</div>
<mat-nav-list>
  <mat-list-item *ngFor="let item of data.butts" (click)="selectButt(item)">
    <div class="text-left" matLine>
      {{ item.name }}
      <span *ngIf="item.article">(<span i18n>Артикул</span>{{ item.article }})</span>
      {{ item.thickness }}mm
    </div>
  </mat-list-item>
</mat-nav-list>
